/**
 * {@link https://www.w3.org/TR/css-grid-2/#grid-container}
 *
 * @internal
 */
export function isGridContainer(style) {
    const [_, inside] = style.computed("display").value.values;
    return inside?.value === "grid";
}
//# sourceMappingURL=is-grid-container.js.map